import { Button, Typography, Dialog, Stack, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'
import SharePublicRolePlayButton from './SharePublicRolePlayButton'

const PublicRolePlayLimitReached = ({ open, setOpen }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const dialogStyles = {
    '& .MuiDialog-paper': {
      width: 500,
      backgroundColor:
        theme.palette.background.yellow || theme.palette.background.paper
    }
  }

  return (
    <Dialog open={open} sx={dialogStyles}>
      <Stack spacing={12}>
        <Stack spacing={4} padding={0} textAlign={'center'}>
          <Typography variant='h2' color={colors.Watermelon400}>
            {t('publicRolePlay.limitReached')}
          </Typography>
          <Typography variant='body1Large'>
            {t('publicRolePlay.reachedYourLimit')}
          </Typography>
        </Stack>
        <Stack
          sx={{
            ...theme.publicRolePlay.stack,
            justifyContent: 'center',
            gap: 4
          }}>
          <SharePublicRolePlayButton
            btnSx={{
              border: `1px solid ${colors.Watermelon400}`,
              color: colors.Watermelon400
            }}
          />
          <Button
            onClick={() => setOpen(false)}
            sx={{
              backgroundColor: colors.Watermelon400,
              color: colors.White,
              '&:hover': {
                backgroundColor: colors.Watermelon400
              }
            }}>
            {t('common.done')}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  )
}

export default PublicRolePlayLimitReached
